document.addEventListener("DOMContentLoaded", () => {
  const accordions = document.querySelectorAll(".collapsible-content details");

  accordions.forEach((accordion) => {
    const summary = accordion.querySelector("summary");

    if (!summary) return;

    // Initial sync (falls erstes Element geöffnet sein soll)
    summary.setAttribute("aria-expanded", accordion.hasAttribute("open") ? "true" : "false");

    accordion.addEventListener("toggle", () => {
      const isOpen = accordion.hasAttribute("open");

      summary.setAttribute("aria-expanded", isOpen ? "true" : "false");
    });
  });
});